/**
 * 主食配置表
 * @constructor
 */
export default function StapleFoodConfig(){
    //主食配置 列表
    const dataJson : StapleFoodEntity[] = [
        {
            uniqueId : 1,
            type : 1,
            typeName : "主食",
            name : "米饭",
            foodMaterialArray : [
                { id : 4 , posIndex : 1 },
                { id : 5 , posIndex : 2 },
                { id : 2 , posIndex : 3 },
                { id : 6 , posIndex : 4 },
                { id : 8 , posIndex : 5 },
                { id : 7 , posIndex : 6 },
            ],
            basicPrice : 150,
            combinationUpPrice : 20,
            combinationDownPrice : 10,
        },
        {
            uniqueId : 2,
            type : 2,
            typeName : "饮品",
            name : "可乐",
            foodMaterialArray : [
                { id : 1 , posIndex : 1 },
                { id : 3 , posIndex : 2 },
                { id : 5 , posIndex : 3 },
                { id : 8 , posIndex : 4 },
            ],
            basicPrice : 80,
            combinationUpPrice : 50,
            combinationDownPrice : 20,
        },
        {
            uniqueId : 3,
            type : 3,
            typeName : "甜品",
            name : "蛋糕",
            foodMaterialArray : [
                { id : 1 , posIndex : 1 },
                { id : 8 , posIndex : 2 },
                { id : 2 , posIndex : 3 },
                { id : 3 , posIndex : 4 },
                { id : 5 , posIndex : 5 },
            ],
            basicPrice : 100,
            combinationUpPrice : 80,
            combinationDownPrice : 10,
        },
    ];
    return dataJson;
}

/**
 * 主食配置类
 */
export class StapleFoodEntity {
    uniqueId : number;
    type : number;//类型<1 饮料,2 主食 , 3 甜品>
    typeName : string;//类型名称
    name : string;//名称
    foodMaterialArray : FoodMaterialPos[];//食材
    basicPrice : number;//基础价格
    combinationUpPrice : number;//组合 适合上升价值
    combinationDownPrice : number;//组合 不适合 掉落的价值
}

/**
 * 食材 位置信息
 */
export class FoodMaterialPos{
    id : number ;//食物id
    posIndex : number;//下标
}

/**
 * 获取随机主食
 */
export function getRandomStapleFood() : StapleFoodEntity{
    return StapleFoodConfig()[ Math.floor( Math.random() * StapleFoodConfig().length )]
}

/**
 * 可选组合
 */
export function canChooseCombination( menuStr : string ) : MenuEntity{
    return MenuJson()[menuStr];
}

export function MenuJson(){
    const dataList : MenuMap = new MenuMap();
    dataList["2-8"] = { name : "空气可乐" , price : 2020 };
    dataList["2-8-8"] = { name : "空气可乐" , price : 2000 };
    dataList["2-8-8-8"] = { name : "空气可乐" , price : 2000 };
    dataList["2-1"] = { name : "冰可乐" , price : 300 };
    dataList["2-1-1"] = { name : "冰可乐" , price : 50 };
    dataList["2-1-1-2"] = { name : "柠檬冰可乐" , price : 1800 };
    dataList["2-1-1-1"] = { name : "冰可乐" , price : 50 };
    dataList["2-3"] = { name : "柠檬可乐" , price : 350 };
    dataList["2-3-3"] = { name : "柠檬可乐" , price : 150 };
    dataList["2-3-3-1"] = { name : "柠檬冰可乐" , price : 1800 };
    dataList["2-3-3-3"] = { name : "柠檬可乐" , price : 150 };
    dataList["1-8"] = { name : "空气米饭" , price : 2050 };
    dataList["1-8-8"] = { name : "空气米饭" , price : 2000 };
    dataList["1-8-8-8"] = { name : "空气米饭" , price : 2000 };
    dataList["1-4"] = { name : "便饭" , price : 5 };
    dataList["1-4-4"] = { name : "便饭" , price : 5 };
    dataList["1-4-4-4"] = { name : "便饭" , price : 5 };
    dataList["1-5"] = { name : "黄金炒饭" , price : 600 };
    dataList["1-5-5"] = { name : "黄金炒饭" , price : 600 };
    dataList["1-5-5-5"] = { name : "黄金炒饭" , price : 600 };
    dataList["1-6"] = { name : "蛋炒饭" , price : 350 };
    dataList["1-6-6"] = { name : "蛋炒饭" , price : 100 };
    dataList["1-6-6-6"] = { name : "蛋炒饭" , price : 100 };
    dataList["1-2"] = { name : "海鲜炒饭" , price : 800 };
    dataList["1-2-2"] = { name : "海鲜炒饭" , price : 600 };
    dataList["1-2-2-2"] = { name : "海鲜炒饭" , price : 600 };
    dataList["3-2"] = { name : "龙虾蛋糕" , price : 800 };
    dataList["3-2-2"] = { name : "龙虾蛋糕" , price : 600 };
    dataList["3-2-2-2"] = { name : "龙虾蛋糕" , price : 600 };

    dataList["3-8"] = { name : "空气蛋糕" , price : 2080 };
    dataList["3-8-8"] = { name : "空气蛋糕" , price : 2000 };
    dataList["3-8-8-8"] = { name : "空气蛋糕" , price : 2000 };
    dataList["3-3"] = { name : "酸柠蛋糕" , price : 550 };
    dataList["3-3-3"] = { name : "酸柠蛋糕" , price : 100 };
    dataList["3-3-3-3"] = { name : "酸柠蛋糕" , price : 100 };

    dataList["3-5"] = { name : "黄金蛋糕" , price : 1500 };
    dataList["3-5-5"] = { name : "黄金蛋糕" , price : 600 };
    dataList["3-5-5-5"] = { name : "黄金蛋糕" , price : 600 };

    dataList["2-3-1"] = { name : "柠檬冰可乐" , price : 1800 };
    dataList["2-3-1-3"] = { name : "柠檬冰可乐" , price : 200 };
    dataList["2-3-1-1"] = { name : "柠檬冰可乐" , price : 200 };
    dataList["2-1-3"] = { name : "柠檬冰可乐" , price : 1800 };
    dataList["2-1-3-3"] = { name : "柠檬冰可乐" , price : 200 };
    dataList["2-1-3-1"] = { name : "柠檬冰可乐" , price : 200 };

    dataList["2-5-2"] = { name : "黄金甲" , price : 3000 };
    dataList["2-5-2-5"] = { name : "黄金甲" , price : 600 };
    dataList["2-5-2-2"] = { name : "黄金甲" , price : 600 };
    dataList["2-2-5"] = { name : "黄金甲" , price : 3000 };
    dataList["2-2-5-2"] = { name : "黄金甲" , price : 600 };
    dataList["2-2-5-5"] = { name : "黄金甲" , price : 600 };

    dataList["3-2-5"] = { name : "群英荟萃" , price : 5000 };
    dataList["3-2-5-2"] = { name : "群英荟萃" , price : 600 };
    dataList["3-2-5-5"] = { name : "群英荟萃" , price : 600 };
    dataList["3-5-2"] = { name : "群英荟萃" , price : 5000 };
    dataList["3-5-2-2"] = { name : "群英荟萃" , price : 600 };
    dataList["3-5-2-5"] = { name : "群英荟萃" , price : 600 };

    dataList["2-5-1-3"] = { name : "还魂水" , price : 30000 , transferFlag : true};
    dataList["2-5-3-1"] = { name : "还魂水" , price : 30000 , transferFlag : true};
    dataList["2-1-5-3"] = { name : "还魂水" , price : 30000 , transferFlag : true};
    dataList["2-1-3-5"] = { name : "还魂水" , price : 30000 , transferFlag : true};
    dataList["2-3-5-1"] = { name : "还魂水" , price : 30000 , transferFlag : true};
    dataList["2-3-1-5"] = { name : "还魂水" , price : 30000 , transferFlag : true};
    dataList["1-2-5-6"] = { name : "世纪炒饭" , price : 45000 , transferFlag : true};
    dataList["1-2-6-5"] = { name : "世纪炒饭" , price : 45000 , transferFlag : true};
    dataList["1-5-2-6"] = { name : "世纪炒饭" , price : 45000 , transferFlag : true};
    dataList["1-5-6-2"] = { name : "世纪炒饭" , price : 45000 , transferFlag : true};
    dataList["1-6-5-2"] = { name : "世纪炒饭" , price : 45000 , transferFlag : true};
    dataList["1-6-2-5"] = { name : "世纪炒饭" , price : 45000 , transferFlag : true};
    dataList["3-3-5-1"] = { name : "鎏金冰川" , price : 50000 , transferFlag : true};
    dataList["3-3-1-5"] = { name : "鎏金冰川" , price : 50000 , transferFlag : true};
    dataList["3-1-5-3"] = { name : "鎏金冰川" , price : 50000 , transferFlag : true};
    dataList["3-1-3-5"] = { name : "鎏金冰川" , price : 50000 , transferFlag : true};
    dataList["3-5-3-1"] = { name : "鎏金冰川" , price : 50000 , transferFlag : true};
    dataList["3-5-1-3"] = { name : "鎏金冰川" , price : 50000 , transferFlag : true};
    dataList["1-4-7-7"] = { name : "九转大肠" , price : 60000 , transferFlag : true};
    dataList["1-7-4-7"] = { name : "九转大肠" , price : 60000 , transferFlag : true};
    dataList["1-7-7-4"] = { name : "九转大肠" , price : 60000 , transferFlag : true};
    return dataList;
}

//菜单map
export class MenuMap{
    [ uniqueIdStr : string ] : MenuEntity;
}
//菜单实体
export interface MenuEntity {
    name : string;
    price : number;
    transferFlag ?: boolean;
}
